<template>
  <div>
    <base-engagement-tool
      :pageHeadingInfo="pageHeadingInfo"
      :linkGoalInfo="linkGoalInfo"
      :leftToolSummary="leftToolSummary"
      :rightToolSummary="rightToolSummary"
      :formModel="formModel"
      :chartTabContent="chartTabContentGraph"
      :chartProperties="chartProperties"
      :selectedComponent="selectedtabComponent"
      :chartData="chartGraphData"
      :secondSelectData="secondSelectData"
      :firstSelectData="firstSelectData"
      :firstOptionLabel="firstOptionLabel"
      :secondOptionLabel="secondOptionLabel"
      :projectionYear="projectionYear"
      :downloadOption="reportDownloadOption"
      downloadLabelName="Report"
      :isShowDownloadIcon="true"
      imageheight="45"
      imagewidth="45"
      @submit="applyFilter"
      @reset="resetForm"
      @formChange="formChange"
      @cancelInstance="cancelInstance"
      @saveInstance="saveInstance"
      @onBack="onBack"
      @changeLoanInfo="changeLoanInfo"
      @refresh="refreshOutstandingBalance"
      @linkClick="genericMethodClick"
      @EditAdditionalform="EditAdditionalform"
      @changeProjectionYear="changeProjectionYear"
      @onChangeChartTab="onChangeChartTab"
      :cardData="cardData"
      @dropDownChange="genericMethodClick"
      @downloadExcelFile="downloadReport"
      :showTableView="showTableView"
      :tableViewSettings="tableViewSettings"
      :buttonDataTypeConfig="buttonDataTypeConfig"
      :buttonViewTypeConfig="buttonViewTypeConfig"
      @onSelectDataTypeFilter="onSelectDataTypeFilter"
      @onSelectViewTypeFilter="onSelectViewTypeFilter"
    ></base-engagement-tool>
    <confirmation-dialog
      v-for="dialog in confirmationDialogList"
      :key="dialog.id"
      :dialog="dialog"
      @buttonclick="genericMethodClick"
    ></confirmation-dialog>

    <component
      :is="selectedComponent"
      :isopenModel="isopenModel"
      :baselineData="baselineData"
      :openTabName="openTabName"
      @closeModel="closeModel"
      @saveData="resetLoanModel"
      :tableViewSettings="tableViewSettings"
      :showTableView="GraphViewType == 3"
      v-if="selectedComponent != null"
    >
    </component>
  </div>
</template>

<script>
import { BaseEngagementTool } from "../../component/loan";
import { ConfirmationDialog } from "../../component/tool";
import LoanAdvanceFilter from "./loan-advance-filter.vue";
import { CommonHelper } from "../../helpers";
import Loan from "../../models/loan";
import { LoanService } from "../../services";
import {
  LoanEngagementTool,
  EngagementBasicScreen,
  UserEvent,
} from "../../mixin";
import {
  LoanSelected,
  UpdateAction,
  DownloadExcelFile,
  AdvaceGraphAction,
  SaveAction,
  DownloadPDFFile,
  DownloadWordFile,
} from "../../helpers/userEvent";
import {
  GET_SELECTED_LIABLITY_INFORMATION,
  GET_Liablity_ENTITY_INFORMATION,
  GET_LOAN_CHART_MODEL,
  GET_Liablity_TYPE_INFORMATION,
  SET_ICE_API_RESPONSE,
  SET_LOAN_CHART_MODEL,
  SET_NOTIFICATION_SUMMARY,
  SET_SELECTED_Liablity_INFORMATION,
  GET_LIABLITY_INFORMATION,
  GET_ICE_PROJECTION_MODEL,
  SET_LOADER_VISIBILITY,
} from "../../helpers/vuex-constants";
import {
  DurationType,
  RepaymentTypeOptions,
  RepeymentTypeSelectOptions,
  RepaymentTypeOptionValue,
  DownloadOption,
  tableViewAreaLoan,
} from "../../helpers/constant";
import { mapGetters, mapActions } from "vuex";

import { ICELoanIntegration, ExcelDownload } from "../../mixin";

import {
  AdvanceFilter,
  AdvanceFilterComponetName,
} from "../../helpers/constant";

export default {
  components: {
    BaseEngagementTool,
    ConfirmationDialog,
    LoanAdvanceFilter,
  },
  data() {
    return {
      selectedComponent: "",
      selectedChartComponent: "chart-area",
      baselineData: "",
      openTabName: "",
      reportDownloadOption: DownloadOption,
      refreshKey: 0,
      isopenModel: false,

      lastprojectionYear: 0,
      pageHeadingInfo: {
        heading: "Enter and test loan details",
        headingIconText: " test hover",
        subHeading:
          "You can keep adjusting until you are happy with the outcome",
      },

      loanModel: {},
      tableViewSettings: {},
      showTableView: false,
      buttonDataTypeConfig: [],
      buttonViewTypeConfig: [],
    };
  },
  mounted() {
    this.projectionYear.Value = this.selectedLoanData.projectionYear;
    this.applyFilter();
    this.formChange(this.formModel);
    this.setAddtionFilterInfoInFormModel();
  },

  async created() {
    this.setChartViewTypeDropDown();
    //   this.setChartDataTypeDropDown();
  },

  computed: {
    GraphViewType() {
      return this.currentGraphView;
    },
    chartTabContentGraph() {
      if (this.showTableView) {
        return this.chartTabContentTableView;
      } else {
        return this.chartTabContent;
      }
    },
    cardData() {
      return {
        description: this.selectedLoanData.description,
        imagepath: require(`../../assets/icons/loans.svg`),
      };
    },

    firstOptionLabel() {
      this.refreshKey;
      let selectedOwner = this.firstSelectData.filter(
        (sr) => sr.value == this.selectedLoanData.ownerId
      );

      return {
        value: this.selectedLoanData.ownerId,
        text:
          selectedOwner.length > 0
            ? selectedOwner[0].text.replace(/(^MRS|MR|MISS)/gi, "")
            : "",
      };
    },
    secondOptionLabel() {
      this.refreshKey;
      return {
        value: this.selectedLoanData.loanTypeId,
        text: this.selectedLoanData.loanTypeName,
      };
    },
    formModel() {
      let userSelectedLoan = this.getLiablityInformation.filter(
        (sr) => sr.liabilityGuid == this.selectedLoanData.liabilityGuid
      );

      return {
        type: "Form",
        groupFormat: [
          { name: "", element: [0], class: "" },
          { name: "RATES", element: [1, 2], class: "group-section" },
          {
            name: "REPAYMENT",
            element: [3, 4, 5, 6, 7],
            class: "group-section",
          },
          { name: "", element: [8, 9, 10], class: "" },
        ],
        elements: [
          {
            type: "FormField",
            id: "369",
            name: "Initial Balance",
            dataType: "text",
            displayType: "slider",
            htmlName: "initialbalance",
            options: [],
            defaultValue:
              userSelectedLoan.length > 0
                ? userSelectedLoan[0].outstandingAmount
                : 0,
            value: this.selectedLoanData.outstandingAmount,
            lastIceValue: this.selectedLoanData.outstandingAmount,
            minValue: 0,
            maxValue: 2000000,
            inputMax: 999999999,
            step: 10000,
            inputFormat: "$,",
            isShowRefreshIcon: this.selectedLoanData.isFactDataChanges,
            originalValue: this.selectedLoanData.factOutstandingBalance,
            tooltipMessage: "Import latest balance from FactFind",
            refreshText: "Use latest balance",
            ischeckRefreshIcon: this.selectedLoanData.isFromFact,
            isCurrencyFormat: true,
            maxlength: 9,
          },
          {
            type: "FormField",
            id: "370",
            name: "Interest Rate",
            dataType: "text",
            displayType: "slider",
            htmlName: "interestRate",
            step: 0.25,
            options: [],
            isShowDecimal: true,
            defaultValue:
              userSelectedLoan.length > 0
                ? userSelectedLoan[0].interestRate
                : 0,
            value: this.selectedLoanData.interestRate,
            lastIceValue: this.selectedLoanData.interestRate,
            minValue: 0,

            maxValue: 15,
            inputMax: 99.99,
            validations: [],
            inputFormat: "%",
            maxlength: 5,
          },
          {
            type: "FormField",
            id: "371",
            name: "Adjustment",
            dataType: "text",
            displayType: "AdditionalInformation",
            htmlName: "AdditionalFieldInterest",
            options: [],
            defaultValue: 0,
            value: 0,
            validations: [],
            inputFormat: "%",
          },
          {
            type: "FormField",
            id: "380",
            name: "Loan Term(Years)",
            dataType: "text",
            displayType: "slider",
            htmlName: "loanterm",
            step: 1,
            options: [],
            isShowDecimal: false,
            defaultValue:
              userSelectedLoan.length > 0 ? userSelectedLoan[0].term : 0,
            value: this.selectedLoanData.term,
            lastIceValue: this.selectedLoanData.term,
            minValue: 0,
            maxValue: 30,
            inputMax: 99,
            inputFormat: "",
            validations: [],
            maxlength: 2,
          },
          {
            type: "FormField",
            id: "373",
            name: "Repayment Frequency",
            dataType: "text",
            displayType: "singleSelect",
            htmlName: "repaymentFrequency",
            options: [
              {
                text: "Weekly",
                value: "5",
              },
              {
                text: "Fortnightly",
                value: "4",
              },
              {
                text: "Monthly",
                value: "3",
              },
            ],
            defaultValue:
              userSelectedLoan.length > 0
                ? userSelectedLoan[0].durationTypeId
                : DurationType.Weeks,
            value: this.selectedLoanData.durationTypeId,
            lastIceValue: this.selectedLoanData.durationTypeId,
            validations: [],
          },
          {
            type: "FormField",
            id: "371",
            name: "Repayment Type",
            dataType: "text",
            displayType: "singleSelect",
            htmlName: "repaymentType",
            emitevent: "onChangeRepaymentType",
            options: RepaymentTypeOptions,
            defaultValue:
              userSelectedLoan.length > 0
                ? userSelectedLoan[0].liabilityTypeId
                : RepaymentTypeOptionValue.Minimum_Repayment,
            lastIceValue: this.selectedLoanData.liabilityTypeId,
            value: this.selectedLoanData.liabilityTypeId,
            validations: [],
          },
          {
            type: "FormField",
            id: "372",
            name: "Repayment Amount",
            dataType: "text",
            displayType: "slider",
            htmlName: "repaymentAmount",
            step: 100,
            options: [],
            defaultValue:
              userSelectedLoan.length > 0
                ? userSelectedLoan[0].repaymentAmount
                : 0,
            value: this.selectedLoanData.repaymentAmount,
            lastIceValue: this.selectedLoanData.repaymentAmount,
            minValue: 0,
            isdisabled:
              this.selectedLoanData.liabilityTypeId ==
              RepaymentTypeOptionValue.Specific_Repayment_Amount
                ? false
                : true,
            maxValue: 20000,
            inputMax: 999999999,
            validations: [],
            inputFormat: "$,",
            isCurrencyFormat: true,
            maxlength: 9,
          },

          {
            type: "FormField",
            id: "371",
            name: "Adjustment",
            dataType: "text",
            displayType: "AdditionalInformation",
            htmlName: "AdditionalFieldRepayment",
            options: [],
            defaultValue: 0,
            value: 0,
            validations: [],
            inputFormat: "%",
          },

          {
            type: "FormField",
            id: "374",
            name: "Update",
            style: "",
            dataType: "submit",
            displayType: "submit",
            htmlName: "submit",
            validations: [],
          },
          {
            type: "FormField",
            id: "375",
            name: "Reset",
            style: '{"margin-left":"20px"}',
            dataType: "text",
            displayType: "reset",
            htmlName: "submit",
            isdisabled: true,
            validations: [],
          },
          {
            type: "FormField",
            id: "376",
            name: "Advanced",
            style: '{"margin-left":"20px"}',
            dataType: "text",
            displayType: "link",
            method: "openAdvancedFilter",
            htmlName: "link",
            isdisabled: true,
            validations: [],
          },
        ],
        htmlName: "LoanBasicFilter",
        isResponsive: "true",
        size: {
          type: "Size",
          width: "0",
          height: "0",
        },
      };
    },

    ...mapGetters("loan", {
      selectedLoanData: GET_SELECTED_LIABLITY_INFORMATION,
      firstSelectData: GET_Liablity_ENTITY_INFORMATION,
      secondSelectData: GET_Liablity_TYPE_INFORMATION,
      getLiablityInformation: GET_LIABLITY_INFORMATION,
      advanceScreenloanChartModel: GET_LOAN_CHART_MODEL,
      getIceProjectionModel: GET_ICE_PROJECTION_MODEL,
    }),
  },
  mixins: [
    LoanEngagementTool,
    ICELoanIntegration,
    EngagementBasicScreen,
    UserEvent,
    ExcelDownload,
  ],
  methods: {
    onSelectViewTypeFilter(button, data) {
      button.toggle2 = false;
      this.buttonViewTypeConfig[0].listItems.forEach(
        (m) => (m.isActive = false)
      );
      data.isActive = true;
      button.text = "View: " + data.itemText.slice(0, -5);
      this.showTableView = data.itemValue == 3;
      this.currentGraphView = data.itemValue;
    },
    ...mapActions({
      setLoaderVisibility: SET_LOADER_VISIBILITY,
    }),
    onLeave(event) {
      let isFormChanges = this.formModel.elements.findIndex(
        (sr) => sr.defaultValue != sr.value
      );
      if (isFormChanges >= 0) {
        event.preventDefault();
        event.returnValue =
          "You have unsaved changes. Are you sure you want to leave this page? Unsaved changes will be lost.";
      }
    },
    onChangeRepaymentType(data) {
      this.setFormProperties("repaymentType", data.value, "value");
      if (data.value == RepaymentTypeOptionValue.Specific_Repayment_Amount) {
        this.setFormProperties("repaymentAmount", false, "isdisabled");
      } else {
        this.setFormProperties("repaymentAmount", true, "isdisabled");
        this.setFormProperties("repaymentAmount", 0, "value");
      }
    },
    AdvancedFilterData(advanceFilterSetting) {
      if (!advanceFilterSetting || advanceFilterSetting.length == 0) {
        return [];
      }
      let advancedata = advanceFilterSetting.map((r) => {
        let p = {
          label: null,
          typeId: null,
          data: [],
        };

        let startMonth =
          !r.startDate || r.startDate == ""
            ? r.startDate
            : CommonHelper.getMonthName(
                CommonHelper.getMonthfromMonthYear(r.startDate)
              );
        let startYear =
          !r.startDate || r.startDate == ""
            ? r.startDate
            : CommonHelper.getYearfromMonthYear(r.startDate);
        let endMonth =
          !r.endDate || r.endDate == ""
            ? r.endDate
            : CommonHelper.getMonthName(
                CommonHelper.getMonthfromMonthYear(r.endDate)
              );
        let endYear =
          !r.endDate || r.endDate == ""
            ? r.endDate
            : CommonHelper.getYearfromMonthYear(r.endDate);
        p.typeId = r.typeId;
        if (r.description == undefined || r.description != "") {
          p.label = r.description;
        } else {
          p.label = this.DescriptionAdditionalForm(
            r.descriptionplaceholder,
            r.typeId
          );
        }
        if (r.typeId == 1) {
          p.data[0] = `Interest rate ${r.amount} %`;
        } else if (r.typeId == 2) {
          p.data[0] = `${
            r.amount == 0
              ? ""
              : CommonHelper.convertIntoCurrencyWithoutDecimal(r.amount)
          }  ${
            r.repaymentType > 0
              ? RepeymentTypeSelectOptions.filter(
                  (x) => x.value == r.repaymentType
                )[0].text
              : CommonHelper.getRaymentType(r.subTypeId)
          }   `;
        } else if (r.typeId == 4) {
          p.data[0] = CommonHelper.calculateMonth(
            r.adjustedTerm * 12 + r.amount
          );
        }
        if (r.typeId == 4) {
          p.data[1] = startMonth + " " + startYear;
        } else if (r.typeId == 3) {
          p.data[0] = `${CommonHelper.convertIntoCurrencyWithoutDecimal(
            r.amount
          )}  ${CommonHelper.getFrequencyName(r.frequency)} `;
          p.data[1] = `${startMonth}
            ${startYear}  ${endMonth ? "-" : ""} ${endMonth}
            ${endYear}`;
        } else {
          p.data[1] = `${startMonth}
            ${startYear}  ${endMonth ? "-" : ""} ${endMonth}
            ${endYear}`;
        }
        return p;
      });
      return advancedata;
    },

    setAddtionFilterInfoInFormModel() {
      let additionalFilter = this.AdvancedFilterData(
        this.selectedLoanData.advancedetails
      );
      if (additionalFilter && additionalFilter.length > 0) {
        this.setFormProperties(
          "AdditionalFieldInterest",
          additionalFilter.filter(
            (sr) => sr.typeId == AdvanceFilter.Interest_Rate
          ),
          "options"
        );
        this.setFormProperties(
          "AdditionalFieldRepayment",
          additionalFilter.filter(
            (sr) => sr.typeId != AdvanceFilter.Interest_Rate
          ),
          "options"
        );
      } else {
        this.setFormProperties("AdditionalFieldInterest", [], "options");
        this.setFormProperties("AdditionalFieldRepayment", [], "options");
      }
    },
    ...mapActions("loan", {
      setIceApiResponse: SET_ICE_API_RESPONSE,
      setLoanChartModel: SET_LOAN_CHART_MODEL,

      setSelectedLiabilityInfo: SET_SELECTED_Liablity_INFORMATION,
    }),
    ...mapActions({
      setNotificationSummary: SET_NOTIFICATION_SUMMARY,
    }),

    EditAdditionalform(data) {
      if (data.typeId == AdvanceFilter.Interest_Rate) {
        this.openTabName = AdvanceFilterComponetName.Interest_Rate;
      } else if (data.typeId == AdvanceFilter.Repayment) {
        this.openTabName = AdvanceFilterComponetName.Repayment;
      } else if (data.typeId == AdvanceFilter.LoanTerm) {
        this.openTabName = AdvanceFilterComponetName.LoanTerm;
      } else if (data.typeId == AdvanceFilter.DrawDown) {
        this.openTabName = AdvanceFilterComponetName.DrawDown;
      }
      this.openAdvancedFilter();
    },
    genericMethodClick(function_name, data) {
      this[function_name](data);
    },
    cancelInstance() {
      this.confirmationDialogList[2].toggle = true;
    },
    saveInstance() {
      if (!this.validationsProjectionYear()) {
        return false;
      }
      if (
        this.selectedLoanData.liabilityGuid ==
        "00000000-0000-0000-0000-000000000000"
      ) {
        this.saveButtonDialogSaveAs_Click();
      } else {
        this.confirmationDialogList[1].toggle = true;
      }
    },
    onBack() {
      let resetButtonIndex = this.formModel.elements.findIndex(
        (sr) => sr.displayType == "reset"
      );
      if (resetButtonIndex >= 0) {
        if (this.formModel.elements[resetButtonIndex].isdisabled) {
          this.$router.push({ name: "loan-instance-selection" });
        } else {
          this.confirmationDialogList[0].toggle = true;
        }
      }
    },

    backButtonDialogDiscard_Click() {
      this.$router.push({ name: "loan-instance-selection" });
    },
    cancelButtonDialogDiscard_Click() {
      this.$router.push({ name: "engagement-tool-selection" });
    },
    backButtonDialogCancel_Click() {},
    backButtonDialogSave_Click() {
      this.confirmationDialogList.forEach((item) => {
        item.toggle = false;
      });
      this.confirmationDialogList[1].toggle = true;
    },

    saveButtonDialogCancel_Click() {},

    async saveButtonDialogSave_Click() {
      let iscallIceApi = this.IsNeedtoCallIceAPI();
      let isUpdate = 0;
      let resetButtonIndex = this.formModel.elements.findIndex(
        (sr) => sr.displayType == "reset"
      );
      if (resetButtonIndex >= 0) {
        if (this.formModel.elements[resetButtonIndex].isdisabled) {
          isUpdate = 0;
        } else {
          isUpdate = 1;
        }
      }
      if (iscallIceApi) {
        await this.applyFilter();
      }
      let loanModel = Loan.CreateSaveLoanModel(
        this.formModel,
        this.selectedLoanData
      );
      loanModel.projectionYear = this.projectionYear.Value;
      let saveModel = this.createLoanModel(loanModel);
      let iceProjectionModel = this.getIceProjectionModel;
      this.setLoaderVisibility(true);
      var saveLoanAPiResponse = await LoanService.saveLoanInformation(
        saveModel,
        iceProjectionModel
      );
      this.setLoaderVisibility(false);
      this.saveLoanData(saveLoanAPiResponse, isUpdate);
      this.saveUserSession(LoanSelected, SaveAction, saveModel.loanTypeId + "");
    },
    async saveButtonDialogSaveAs_Click() {
      let iscallIceApi = this.IsNeedtoCallIceAPI();
      if (iscallIceApi) {
        await this.applyFilter();
      }
      this.setIceApiResponse({});
      this.setLoanChartModel(this.loanModel);
      let saveLoanModel = Loan.CreateSaveLoanModel(
        this.formModel,
        this.selectedLoanData
      );
      saveLoanModel.projectionYear = this.projectionYear.Value;
      this.setSelectedLiabilityInfo(saveLoanModel);
      this.$router.push({ name: "save-engagement-tool" });
    },
    enableResetButton(isFormChanges) {
      let resetButtomIndex = this.formModel.elements.findIndex(
        (sr) => sr.displayType == "reset"
      );
      if (resetButtomIndex >= 0) {
        if (isFormChanges) {
          this.formModel.elements[resetButtomIndex].isdisabled = false;
        } else {
          this.formModel.elements[resetButtomIndex].isdisabled = true;
        }
      }
    },

    refreshOutstandingBalance() {
      let elementIndex = this.formModel.elements.findIndex(
        (sr) => sr.htmlName == "initialbalance"
      );
      if (elementIndex >= 0) {
        this.formModel.elements[elementIndex].isShowRefreshIcon = false;
        this.formModel.elements[elementIndex].value =
          this.formModel.elements[elementIndex].originalValue;
        this.enableResetButton(true);
      }
    },
    openAdvancedFilter() {
      this.selectedComponent = "loan-advance-filter";
      this.openTabName =
        this.openTabName == "" ? "loan-interest-rate-filter" : this.openTabName;
      this.isopenModel = true;
      this.loanModel.timeSeriesChartData = [];
      let currentLoanInfo = {};
      Loan.CreateSaveLoanModel(this.formModel, currentLoanInfo);
      this.baselineData = this.getEloquaFormModel(true);

      for (let i = 0; i < this.selectedLoanData.advancedetails.length; i++) {
        this.baselineData.advancedetails.push({
          startDateType: {
            value: this.selectedLoanData.advancedetails[i].startDateType,
            IsError: false,
            ErrorText: [],
          },
          startDate: {
            value: this.selectedLoanData.advancedetails[i].startDate,
            IsError: false,
            ErrorText: [],
          },
          endDateType: {
            value: this.selectedLoanData.advancedetails[i].endDateType,
            IsError: false,
            ErrorText: [],
          },
          endDate: {
            value: this.selectedLoanData.advancedetails[i].endDate,
            IsError: false,
            ErrorText: [],
          },
          index: {
            value: this.selectedLoanData.advancedetails[i].index,
            IsError: false,
            ErrorText: [],
          },
          description: {
            value: this.selectedLoanData.advancedetails[i].description,
            IsError: false,
            ErrorText: [],
          },
          typeId: {
            value: this.selectedLoanData.advancedetails[i].typeId,
            IsError: false,
            ErrorText: [],
          },
          subTypeId: {
            value: this.selectedLoanData.advancedetails[i].subTypeId,
            IsError: false,
            ErrorText: [],
          },
          adjustedTerm: {
            value: this.selectedLoanData.advancedetails[i].adjustedTerm,
            IsError: false,
            ErrorText: [],
          },
          amount: {
            value: this.selectedLoanData.advancedetails[i].amount,
            IsError: false,
            ErrorText: [],
          },
          effectiveAsON: {
            value: this.selectedLoanData.advancedetails[i].effectiveAsON,
            IsError: false,
            ErrorText: [],
          },
          frequency: {
            value: this.selectedLoanData.advancedetails[i].frequency,
            IsError: false,
            ErrorText: [],
          },
          repaymentType: {
            value: this.selectedLoanData.advancedetails[i].repaymentType,
            IsError: false,
            ErrorText: [],
          },
        });
      }
      this.setLoanChartModel(this.loanModel);
      this.saveUserSession(LoanSelected, AdvaceGraphAction, "");
    },
    getvalue(data) {
      if (data == undefined) return 0;
      else return data.value;
    },
    resetLoanModel(baselineModel) {
      this.setFormProperties(
        "interestRate",
        baselineModel.interestRate,
        "value"
      );
      this.setFormProperties(
        "repaymentType",
        baselineModel.repaymentType,
        "value"
      );
      this.setFormProperties(
        "repaymentAmount",
        baselineModel.repaymentAmount,
        "value"
      );
      this.setFormProperties("loanterm", baselineModel.loanTerm, "value");
      if (
        baselineModel.repaymentType ==
        RepaymentTypeOptionValue.Specific_Repayment_Amount
      ) {
        this.setFormProperties("repaymentAmount", false, "isdisabled");
      } else {
        this.setFormProperties("repaymentAmount", true, "isdisabled");
      }
      let newAdvanceDetails = [];
      for (let i = 0; i < baselineModel.advancedetails.length; i++) {
        newAdvanceDetails.push({
          adjustedTerm: this.getvalue(
            baselineModel.advancedetails[i].adjustedTerm
          ),
          index: this.getvalue(baselineModel.advancedetails[i].index),
          amount: this.getvalue(baselineModel.advancedetails[i].amount),
          description: this.getvalue(
            baselineModel.advancedetails[i].description
          ),
          effectiveAsON: this.getvalue(
            baselineModel.advancedetails[i].effectiveAsON
          ),
          endDateType: this.getvalue(
            baselineModel.advancedetails[i].endDateType
          ),
          endDate: baselineModel.advancedetails[i].endDate
            ? this.getvalue(baselineModel.advancedetails[i].endDate)
            : "",
          frequency: this.getvalue(baselineModel.advancedetails[i].frequency),

          startDateType: this.getvalue(
            baselineModel.advancedetails[i].startDateType
          ),
          startDate: baselineModel.advancedetails[i].startDate
            ? this.getvalue(baselineModel.advancedetails[i].startDate)
            : "",
          typeId: this.getvalue(baselineModel.advancedetails[i].typeId),
          subTypeId: this.getvalue(baselineModel.advancedetails[i].subTypeId),
          descriptionplaceholder: this.DescriptionAdditionalForm(
            this.getvalue(baselineModel.advancedetails[i].description),
            baselineModel.advancedetails[i].typeId.value
          ),
          repaymentType: this.getvalue(
            baselineModel.advancedetails[i].repaymentType
          ),
        });
      }

      this.selectedLoanData.advancedetails = newAdvanceDetails;
      this.setAddtionFilterInfoInFormModel();
      this.selectedLoanData.months = baselineModel.loanMonth;
      this.loanModel = this.advanceScreenloanChartModel;
      // this.getIceProjectionModel = Object.assign(
      //   {},
      //   this.loanModel.apiprojectionData
      // );
      this.setTableElements();
      this.ResetGraphsModel();
      this.closeModel();
    },

    setFormProperties(key, value, fieldName) {
      let elementIndex = this.formModel.elements.findIndex(
        (sr) => sr.htmlName == key
      );
      if (elementIndex >= 0) {
        this.formModel.elements[elementIndex][fieldName] = value;
      }
    },
    closeModel() {
      this.isopenModel = false;
      this.selectedComponent = "";
      this.setLoanChartModel({});
    },

    changeLoanInfo(loanInfo) {
      if (loanInfo && loanInfo.option1 && loanInfo.option1.value) {
        this.selectedLoanData.ownerId = loanInfo.option1.value;
        this.selectedLoanData.ownerEntityId = loanInfo.option1.entityType;
      }
      if (loanInfo && loanInfo.option2 && loanInfo.option2.value) {
        this.selectedLoanData.loanTypeId = loanInfo.option2.value;
        this.selectedLoanData.loanTypeName = loanInfo.option2.text;
      }
      this.formChange(this.formModel);
    },
    resetUserLoanInfo() {
      let userSelectedLoan = this.getLiablityInformation.filter(
        (sr) => sr.liabilityGuid == this.selectedLoanData.liabilityGuid
      );
      if (userSelectedLoan && userSelectedLoan.length > 0) {
        this.selectedLoanData.loanTypeId = userSelectedLoan[0].loanTypeId;
        this.selectedLoanData.loanTypeName = userSelectedLoan[0].loanTypeName;
        this.selectedLoanData.ownerId = userSelectedLoan[0].ownerId;
      }
    },
    resetForm() {
      let totalFields = this.formModel.elements.length;
      for (let i = 0; i < totalFields; i++) {
        this.formModel.elements[i].value =
          this.formModel.elements[i].defaultValue;
      }
      this.resetUserLoanInfo();
      this.enableResetButton(false);
      this.refreshKey++;
      this.enableOutStandingRefreshIcon();
    },
    resetLastIceValueInForm() {
      let totalFields = this.formModel.elements.length;
      for (let i = 0; i < totalFields; i++) {
        this.formModel.elements[i].lastIceValue =
          this.formModel.elements[i].value;
      }
    },
    isUserLoanInfoChange() {
      let userSelectedLoan = this.getLiablityInformation.filter(
        (sr) => sr.liabilityGuid == this.selectedLoanData.liabilityGuid
      );
      if (userSelectedLoan && userSelectedLoan.length > 0) {
        if (
          this.selectedLoanData.loanTypeId != userSelectedLoan[0].loanTypeId ||
          this.selectedLoanData.loanTypeName !=
            userSelectedLoan[0].loanTypeName ||
          this.selectedLoanData.ownerId != userSelectedLoan[0].ownerId
        ) {
          this.enableResetButton(true);
        } else {
          this.enableResetButton(false);
        }
      }
    },

    enableOutStandingRefreshIcon() {
      let elementIndex = this.formModel.elements.findIndex(
        (sr) => sr.htmlName == "initialbalance"
      );
      if (elementIndex >= 0) {
        if (
          this.formModel.elements[elementIndex].ischeckRefreshIcon &&
          this.formModel.elements[elementIndex].originalValue !=
            this.formModel.elements[elementIndex].value
        ) {
          this.formModel.elements[elementIndex].isShowRefreshIcon = true;
        }
      }
    },
    formChange() {
      let isFormChanges = this.formModel.elements.findIndex(
        (sr) => sr.defaultValue != sr.value
      );
      if (isFormChanges >= 0) {
        this.enableResetButton(true);
      } else {
        this.isUserLoanInfoChange();
      }
      this.enableOutStandingRefreshIcon();
    },

    IsNeedtoCallIceAPI() {
      let userInputs = this.formModel.elements.filter(
        (sr) => sr.htmlName != "submit"
      );

      if (userInputs && userInputs.length > 0) {
        let userChangedFields = userInputs.filter(
          (sr) => sr.lastIceValue != sr.value
        );
        if (
          this.lastprojectionYear != this.projectionYear.Value ||
          (userChangedFields && userChangedFields.length > 0)
        ) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },

    getEloquaFormModel(isfromAdvanceFilter) {
      let currentLoanInfo = Loan.CreateSaveLoanModel(this.formModel, {});
      return {
        entityType: this.getLiablityInformation
          ? this.getLiablityInformation[0].ownerEntityId
          : "",
        loanType: this.getLiablityInformation
          ? this.getLiablityInformation[0].loanTypeId
          : "",
        openingBalance: currentLoanInfo.outstandingAmount,

        projectionYear: this.projectionYear,
        interestRate: currentLoanInfo.interestRate,
        repaymentType: currentLoanInfo.liabilityTypeId,
        repaymentAmount: currentLoanInfo.repaymentAmount,
        repaymentFrequency: currentLoanInfo.durationTypeId,
        taxDeductibilityPercent:
          this.getLiablityInformation && this.getLiablityInformation.length > 0
            ? this.getLiablityInformation[0].taxDeductibility
            : 0,
        loanTerm: currentLoanInfo.term,
        loanMonth: this.selectedLoanData.months,
        repaymentTypeOption: RepaymentTypeOptions,
        description: this.selectedLoanData.description,
        uniqueId: CommonHelper.uuidv4(),
        advancedetails: isfromAdvanceFilter
          ? []
          : Object.assign([], this.selectedLoanData.advancedetails),
      };
    },

    ResetGraphsModel() {
      this.rightToolSummary = [
        {
          key: "Total Loan Repayment",
          value: this.loanModel.totalLoanRepayment,
        },
        {
          key: "Total Interest",
          value: this.loanModel.totalInterest,
        },
        {
          key: "Loan Paid In",
          value: this.loanModel.LoanPaindId,
        },
      ];
      this.chartData.barChartdata = this.loanModel.barchartData.data;
      this.chartData.areaChartdata = this.loanModel.areaChartData.data;
      this.ResetBarChartProperties();
      this.ResetAreaChartProperties();
      this.resetLastIceValueInForm();
      this.onChangeChartTab(this.selectedtabComponent);
    },
    async applyFilter() {
      this.chartData = {
        barChartdata: [],
        areaChartdata: [],
      };
      if (!this.validationsProjectionYear()) {
        return false;
      }
      this.lastprojectionYear = this.projectionYear.Value;
      let baselineData = this.getEloquaFormModel(false);
      baselineData.loanTerm =
        baselineData.loanTerm * 12 + baselineData.loanMonth;
      let apiModel = this.prepareAPIModel(baselineData);
      this.setLoaderVisibility(true);
      const projectionData = await this.getLoanProjection(
        apiModel,
        this.selectedLoanData.s3FilePath
      );

      this.selectedLoanData.s3FilePath = "";
      this.setLoaderVisibility(false);
      if (projectionData.length == 0) {
        return;
      }
      this.loanModel = this.setLoanModel(projectionData, baselineData);

      this.saveUserSession(LoanSelected, UpdateAction, "");
      this.ResetGraphsModel();
      this.setTableElements();
    },
    setTableElements() {
      if (this.getIceProjectionModel.loanProjectionResult) {
        let i = 0;
        let ageResult = this.getIceProjectionModel.ageResults;
        let data =
          this.getIceProjectionModel.loanProjectionResult[0].loanProjection.map(
            (r) => {
              let p = r;
              p.headeryearage = ageResult
                ? ageResult[i].date +
                  "|" +
                  (ageResult[i].ageClient +
                    (ageResult[i].age_Partner
                      ? "/" + ageResult[i].age_Partner
                      : ""))
                : "";
              i++;
              return p;
            }
          );
        let tableData = this.mapTableView(
          ageResult ? "headeryearage" : "year",
          tableViewAreaLoan,
          data,
          ageResult ? "Year|Age" : "year"
        );
        this.tableViewSettings = tableData;
      }
      console.log(this.tableViewSettings);
    },
    async downloadReport(flag) {
      if (flag == DownloadOption[0].value) {
        this.downloadExcelFile();
      } else if (flag == DownloadOption[1].value) {
        this.saveUserSession(LoanSelected, DownloadPDFFile, "");
        this.downloadPDFFile(0);
      } else {
        this.saveUserSession(LoanSelected, DownloadWordFile, "");
        this.downloadPDFFile(1);
      }
    },
    async downloadPDFFile(flag) {
      let projectiondata = this.getIceProjectionModel;
      let cloneProjection = Object.assign({}, projectiondata);
      let formModel = Object.assign({}, this.formModel);
      let loanData = Object.assign({}, this.selectedLoanData);
      let loanModel = Loan.CreateSaveLoanModel(formModel, loanData);
      this.getPDFFileStream(
        flag,
        this.getfileName(),
        loanData.ownerId,
        JSON.stringify({
          loan: loanModel,
          loanProjectionResult: cloneProjection.loanProjectionResult,
        })
      );
    },

    async downloadExcelFile() {
      this.saveUserSession(LoanSelected, DownloadExcelFile, "");
      let fileName = this.selectedLoanData.description;
      let projectiondata = this.getIceProjectionModel;
      let cloneProjection = Object.assign({}, projectiondata);
      let ownerInfo = this.firstOptionLabel;
      if (ownerInfo && ownerInfo.text) {
        fileName = ownerInfo.text.trim() + "_" + fileName;
      }
      this.getExcelFileStream(cloneProjection, fileName);
    },
    getfileName() {
      let fileName = this.selectedLoanData.description;
      let ownerInfo = this.firstOptionLabel;
      if (ownerInfo && ownerInfo.text) {
        fileName = ownerInfo.text.trim() + "_" + fileName;
      }
      return fileName;
    },
  },
};
</script>

<style lang="scss" module></style>
